const text = {
    platformName: 'BPOINT',
    copyrightFooter: '© 2009-{currentYear} Commonwealth Bank of Australia ABN 48 123 123 124'
};

export default text;